export class ReversibilityDateRange
  {
    public startDate: Date;
    public endDate: Date;
    public isReversible: boolean;
  }
